<script setup lang="ts">
import { useHomeStore } from '~~/stores/home'
import { type BreadcrumbType } from '~~/types/global'

defineOptions({
  name: 'KursusCatalgue'
})

const homeStore: Record<string, any> = useHomeStore()
const latestCourse = computed(() => homeStore.state?.latestCourse)

const breadcrumb = reactive<BreadcrumbType[]>([
  {
    path: '/',
    active: false,
    label: 'Beranda'
  },
  {
    path: '',
    active: true,
    label: 'Kursus'
  }
])

onMounted(() => {
  homeStore.fetchCourses({
    type: 'latestCourse',
    size: 6,
    page: 1
  })
})
</script>

<template>
  <main id="kursus" class="kg-content">
    <div class="container">
      <AtomsBreadcrumbs :breadcrumbs="breadcrumb" />
      <h1 class="kursus-title">Kursus</h1>
    </div>
    <LazyModulesHomeMoleculesSectionCategories />

    <LazyModulesHomeMoleculesSectionCourseLoading
      v-if="latestCourse?.isLoading"
      title="Kursus Terbaru"
      class="my-10"
    />
    <LazyModulesHomeMoleculesSectionCourse
      v-else
      type-ref="kursusTerbaru"
      title="Kursus Terbaru"
      :data="latestCourse?.data ?? []"
      :is-loading="latestCourse?.isLoading ?? false"
      is-see-more
      with-arrow
      class="my-10"
    />
  </main>
</template>

<style lang="scss">
@use './styles.scss';
</style>
